<template>
  <div
      v-background="src"
      class="THUMBNAIL x-pulse" />
</template>

<script>
export default {
  name: 'thumbnail',
  props: {
    src: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .THUMBNAIL {
    @include square(70px);
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
</style>
